import React, { useState } from 'react';
import { DialogActions } from '@mui/material';
import { DesktopDatePicker } from '@mui/x-date-pickers';

import { DD_SLASH_MMM_SLASH_YYYY } from '../../../../../../constants/dateFormat';

import './EdcVisitDatePickerButton.scss';

export default function EdcVisitDatePickerButton({ onChange, value, isAllowedToManage }) {
  const [open, setOpen] = useState(false);
  return (
    <DesktopDatePicker
      open={open}
      onClose={() => setOpen(false)}
      disableFuture={true}
      disabled={!isAllowedToManage()}
      name="date_of_encounter"
      value={value}
      onChange={date => onChange(date)}
      label="Date of Encounter"
      format={DD_SLASH_MMM_SLASH_YYYY}
      views={['year', 'month', 'day']}
      slotProps={{
        textField: {
          onClick: () => setOpen(true),
          variant: 'outlined',
          fullWidth: true,
          placeholder: 'Select',
          size: 'small',
          readOnly: true
        },
        openPickerIcon: {
          onClick: () => setOpen(true)
        }
      }}
      slots={{
        actionBar: () => (
          <DialogActions className="MuiPickersLayout-actionBar visit-date-picker-hint">
            <div>
              This is the official date of the Encounter that corresponds to the visit date defined in the electronic
              data capture (EDC) system.
            </div>
          </DialogActions>
        )
      }}
    />
  );
}
